import React from 'react';
import '../../../styles/style.css';

const RouteDescription = ({ name, description }) => {
  // Разбиваем описание по \n или \\n, убираем пустые строки
  const paragraphs = description
    ? description.split(/\r?\n|\\n/).filter(p => p.trim() !== '')
    : [];

  return (
    <div className="routeInfoWrapper">

      {/* Заголовок */}
      <div className="routeNameWrapper">
        <div className="routeNameInner">
          <h1 className="routeName">{name}</h1>
          <div className="routeNameYellowUnderneath"></div>
        </div>
      </div>

      {/* линия + текст вместе */}
      <div className="routeDescWithLine">

        <div className="routeVerticalLine"></div>

        <div className="routeDescWrapper">
          <div className="routeDesc">
            {paragraphs.map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        </div>

      </div>

    </div>
  );
};

export default RouteDescription;